/* eslint-disable @typescript-eslint/ban-ts-comment */
import { BaseCrudStore } from '@monorepo/controlled/src/stores/base-crud.store';
import { id } from '@monorepo/tools/src/lib/types/primitives';
import { runInAction } from 'mobx';
import { HttpError } from '../../models/http-error.model';
import { BidderApi } from '../../apis/bidder.api';
import { BidderAdvertiserModel } from '../../models/bidder-advertiser.model';
import { BidderAdvertiserResponseModel } from '../../models/bidder-advertiser-response.model';
import { FormError } from '@monorepo/tools/src/lib/models/form-error.model';

// const isFieldFilled = (field: number): boolean => {
// 	return field !== undefined && field !== null && field.toString() !== '';
// };

export class BidderAdvertisersCrudStore extends BaseCrudStore<
	BidderAdvertiserResponseModel,
	BidderAdvertiserModel | undefined,
	BidderAdvertiserModel | undefined,
	HttpError
> {
	constructor() {
		super({
			// @ts-ignore
			apiLayer: BidderApi,
			model: BidderAdvertiserResponseModel,
			errorModel: HttpError,
		});
	}

	public isValid(): boolean {
		this.formStore.reset();
		const { balance, newBalance } = this.data.advertiser;
		if (newBalance !== undefined && balance !== undefined && newBalance < balance) {
			this.formStore.addError(new FormError('balance', 'New balance cannot be less than current balance'));
		}
		return this.formStore.getIsValid();
	}

	getCreateFormData() {
		return this.getData().advertiser;
	}

	getEditFormData() {
		return this.getData().advertiser;
	}

	createInstance(): BidderAdvertiserResponseModel {
		return new BidderAdvertiserResponseModel();
	}

	public async getBidderAdvertiser(id: id) {
		if (this.getIsLocalCache()) {
			return Promise.resolve();
		}

		this.setIsLocalCache(true);
		this.setIsLoading(true);

		try {
			const res = await BidderApi.getBidderAdvertiser(id);
			const data = new this.model(res);
			const originData = new this.model(res);
			runInAction(() => {
				this.setIsLocalCache(false); //TODO: move to finally
				this.setData(data);
				this.setOriginData(originData);
				this.setIsLoading(false);
			});
			return data;
		} catch (error) {
			if (this.onError) {
				const err = error as { data?: any };
				this.onError(err.data);
			}
			runInAction(() => {
				if (this.errorModel) {
					const err = error as { data?: any; response?: { status?: number } };
					this.setHttpError(new this.errorModel({ ...err.data, httpStatus: err.response?.status }));
				}
				this.setIsLoading(false);
				this.setIsSuccess(false);
			});
		}
	}

	async enableAdvertiser(advertiserId: id): Promise<void> {
		this.setIsLoading(true);
		try {
			await BidderApi.enableAdvertiser(advertiserId);
			this.setIsLoading(false);
			this.setIsSuccess(true);
		} catch {
			this.setIsLoading(false);
			this.setIsSuccess(false);
		}
	}

	async pauseAdvertiser(advertisersId: id): Promise<void> {
		this.setIsLoading(true);
		try {
			await BidderApi.pauseAdvertiser(advertisersId);
			this.setIsLoading(false);
			this.setIsSuccess(true);
		} catch {
			this.setIsLoading(false);
			this.setIsSuccess(false);
		}
	}
}
